import { QuickReferenceSection } from '../types';

export const reserve2010QuickReference: QuickReferenceSection[] = [
  {
    id: 'r2010-qr-setup',
    title: 'Przygotowanie',
    content: 'Plansza i planszetki Reserve 2010. Regiony 7/8/9. Limity enologów/farmerów/piwnic/winiarni. Cechy, Fair tiles, bank. Pierwsza winnica + premia regionu.',
    chapterId: 'r2010-setup',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-year',
    title: 'Struktura roku',
    content: 'Start roku → 2 akcje (+ kolejność) → utrzymanie → produkcja → targi (3/5/6).',
    chapterId: 'r2010-year-structure',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-turn',
    title: 'Sekwencja tury',
    content: 'Ewentualna korzyść magnata → ruch na Quadrelu → akcja → ewentualna korzyść magnata.',
    chapterId: 'r2010-movement',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-move',
    title: 'Koszt ruchu',
    content: 'Sąsiad 0; dalej 1; gracze na polu 1 każdy; znacznik roku +1; Pass gratis.',
    chapterId: 'r2010-movement',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-actions',
    title: 'Skrót akcji',
    content: 'Winnice 1/region; winiarnie 1–2×3; enolodzy 1–2×1; piwnica ×2; sprzedaż; eksport; bank; eksperci 1–2×1; Pass/PR.',
    chapterId: 'r2010-vineyards',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-production',
    title: 'Produkcja i wartość',
    content: 'Jakość +2/+1/+1/+2/+3Porto±pogoda. Wartość = jakość + piwnica + renoma + Algarve.',
    chapterId: 'r2010-wine-quality',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-bank',
    title: 'Bankowość',
    content: 'Wypłata/wpłata/inwestycja/divest. Odsetki i pensje tylko z konta.',
    chapterId: 'r2010-bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-sales-export',
    title: 'Sprzedaż i eksport',
    content: 'Sprzedaż → konto ze slotu; pary beczek→renomy. Eksport → VP wiersza; końcowe większości.',
    chapterId: 'r2010-sales',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-fair',
    title: 'Targi',
    content: 'PR: wino, FP>9, Fair tile, stoisko, magnaci. Faza: eksperci, cechy, ranking VP.',
    chapterId: 'r2010-wine-fairs',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-maint',
    title: 'Utrzymanie',
    content: 'Odsetki inwestycji; pensje enologów; kary −2 VP / strata budynków.',
    chapterId: 'r2010-maintenance',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-end',
    title: 'Punktacja końcowa',
    content: 'Konto + eksport większości + mnożniki. Remis: eksport, potem pieniądze.',
    chapterId: 'r2010-end-of-game',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-qr-limits',
    title: 'Najczęściej pomijane',
    content: '4 posiadłości; farmerzy bez TR tylko Ribatejo; limit 6 ekspertów; renomy tylko do progu; magnat ≠ akcja.',
    chapterId: 'r2010-common-mistakes',
    requiredVariantIds: ['reserve-2010'],
  },
];
